import React from 'react';
import { motion } from 'framer-motion';

const MotivationalQuote = ({ quote }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      key={quote} // This ensures animation triggers when quote changes
      className="flex items-center justify-center"
    >
      <div className="text-sm font-medium text-yellow-800 flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
        {quote}
      </div>
    </motion.div>
  );
};

export default MotivationalQuote;
